import { Card, DatePicker } from "antd";
import dayjs from "dayjs";
import CalanderIcon from "../_icons/CalanderIcon";
interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateDate({ data, viewOnly }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          Date - {data?.question_title}
        </div>

        <div className="flex flex-col gap-1 mt-4">
          <label className="text-gray-600 text-sm">Date</label>

          <div className="min-w-[300px]">
            <DatePicker
              disabled={viewOnly}
              value={data.answer ? dayjs(data.answer) : null}
              placeholder="dd/mm/yyyy"
              format="DD/MM/YYYY"
              suffixIcon={<CalanderIcon />}
              className="border-0 border-b border-slate-400 rounded-none min-w-[300px]  px-0 text-gray-600 placeholder:text-gray-400 focus:shadow-none focus:border-slate-600"
            />
          </div>
        </div>
      </Card>
    </>
  );
}
